import { getDataJWTWrapper, getDataWrapper } from '@App/api/helper'
import { $host } from '@App/api/index'

import { ICreateAccountData, IEditAccountData, IMoveAccountMoneyData } from '@Redux/slices/user/types'

import { IAccountDepositRequest, IDepositRequest } from '@Interfaces/CommonInterfaces'

export const deposit = async (data: IDepositRequest) => await getDataJWTWrapper($host.post('api/me/deposit', data))
export const accountDeposit = async (data: IAccountDepositRequest) => await getDataJWTWrapper($host.post('InternalApi/account/deposit', data))

export const createPaymentIntent = async (data: any) => await getDataWrapper($host.post('api/me/intent', data))
export const withdrawal = async (currency: string, value: number) =>
  await getDataJWTWrapper($host.post('api/me/withdrawal', { currency, value }))

export const changeNickname = async (nickname: string) => await getDataWrapper($host.patch('api/me', { nickname }))

export const generateSecretKey = async () => await getDataWrapper($host.post('api/me/two-factor/generate-secret-key'))

export const sendEmailVerificationCode = async () => await getDataWrapper($host.post('api/me/send-email-verify-code'))

export const sendNewEmailVerificationCode = async (email: string) =>
  await getDataWrapper($host.post(`api/me/send-email-verify-code-for-change`, { email: email }))

export const editEmail = async (data: any) => await getDataWrapper($host.post(`api/me/email/change`, data))

export const enable2FA = async (code: string, secretKey: string) => {
  try {
    return await getDataWrapper(
      $host.post('api/me/two-factor/enable', {
        verification_code: code,
        two_fa_secret: secretKey,
      }),
    )
  } catch (e: any) {
    return e.response.data.message
  }
}

export const disable2FA = async (code: string) => {
  try {
    return await getDataWrapper(
      $host.post('api/me/two-factor/disable', {
        verification_code: code,
      }),
    )
  } catch (e: any) {
    return e.response.data.message
  }
}

export const editAccount = async (params: IEditAccountData) =>
  await getDataWrapper($host.put('InternalApi/account/edit', params))

export const createAccount = async (params: ICreateAccountData) =>
  await getDataWrapper($host.post('InternalApi/account/create', params))

export const moveAccountMoney = async (params: IMoveAccountMoneyData) =>
  await getDataWrapper($host.put('InternalApi/account/move_money', params))

export const getUserRealityCheck = async () => {
  return await getDataWrapper($host.post('InternalApi/user/reality_check/get'))
}

export const acceptNewPolicy = async (params: any) => {
  await getDataWrapper($host.post('InternalApi/user/accept_new_policy', params))
}

export const serverValidate = async (params: any) => {
  return await getDataWrapper($host.post('InternalApi/services/registration/validate', params))
}

export const getUserLimits = async () => {
  return await getDataWrapper($host.post('InternalApi/user/limits/get'))
}

export const setUserLimits = async (params: any) => {
  return await getDataWrapper($host.post('InternalApi/user/limits/set', params))
}

export const editRealityChecksPeriod = async (params: any) => {
  return await getDataWrapper($host.post('InternalApi/user/reality_check/edit', params))
}

export const editUserSettings = async (params: any) => {
  return await getDataWrapper($host.post('InternalApi/user/settings/set', params))
}

export const setSelfExclusion = async (params: any) => {
  return await getDataWrapper($host.post('InternalApi/user/limits/set_exclude', params))
}

export const userCloseAccount = async (params: any) => {
  return await getDataWrapper($host.post('InternalApi/user/close', params))
}

export const getUserDocumentFiles = async () => {
  return await getDataWrapper($host.post('InternalApi/user/document/files'))
}

export const getUserImageUrlRequest = async (params: any) => {
  return await getDataWrapper($host.post('InternalApi/user/image/get', params))
}

export const deleteUserUploadFile = async (params: any) => {
  return await getDataWrapper($host.post('InternalApi/user/document/delete', params))
}

export const uploadUserImage = async (params: any) => {
  return await getDataWrapper($host.post('InternalApi/user/document/upload', params))
}

export const checkUserAnswers = async (params: any) => {
  return await getDataWrapper($host.post('InternalApi/user/answer/check', params))
}

export const editTimeoutsProblemGambler = async (params: any) => {
  return await getDataWrapper($host.post('InternalApi/user/timeout/edit', params))
}